(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('SubscribedCountries', SubscribedCountries);

    SubscribedCountries.$inject = ['$resource'];

    function SubscribedCountries ($resource) {
        var resourceUrl =  'api/subscribedCountries';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
